import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "openIcon", "closeIcon"]

  connect() {
    this.#syncIcons(false)
  }

  toggle() {
    const open = this.panelTarget.classList.toggle("open")
    this.#syncIcons(open)
  }

  // Close when a nav link inside the panel is tapped
  close() {
    this.panelTarget.classList.remove("open")
    this.#syncIcons(false)
  }

  #syncIcons(open) {
    if (this.hasOpenIconTarget) this.openIconTarget.classList.toggle("hidden", open)
    if (this.hasCloseIconTarget) this.closeIconTarget.classList.toggle("hidden", !open)
  }
}
